import * as  DeviceActions from './devices.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { Device, ProductFacet, ProductSort } from '@kion/data-models';

export const DEVICES_FEATURE_KEY = 'device';

export interface DevicesState extends EntityState<Device> {
  error?: any;
  lastCreatedId: string|null;

  isSearching: boolean;
  searchResultIds: string[];
  pagination: {
    page: number,
    perPage: number,
    totalPages: number,
    count: number,
    total: number
  }
  query: string
  sorts: ProductSort[]
  facets: ProductFacet[]
  actualSort: string,
  totalResult: number
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>();

export interface DevicesPartialState {
  readonly [DEVICES_FEATURE_KEY]: DevicesState;
}

export const initialState: DevicesState = adapter.getInitialState({
  lastCreatedId: null,
  isSearching: false,
  searchResultIds: [],
  searchQuery: {},
  pagination: {
    page: 1,
    perPage: 20,
    totalPages: 0,
    count: 0,
    total: 0
  },
  query: null,
  sorts: [],
  facets: [],
  actualSort: null,
  totalResult: 0
});

const DevicesReducer = createReducer(
  initialState,
  on(
    DeviceActions.searchSuccess,
    (state, { searchResult  }) => {
      return adapter.upsertMany(
        searchResult.devices,
        {
          ...state,
          isSearching: false,
          searchResultIds: searchResult.devices.map(
            (device: Device) => device.id
          ),
          pagination: {
            page: searchResult.pagination.currentPage + 1,
            perPage: searchResult.pagination.pageSize,
            totalPages: searchResult.pagination.totalPages,
            total: searchResult.pagination.totalResults
          },
          query: searchResult.query ? decodeURIComponent(searchResult.query) : null,
          sorts: searchResult.sorts,
          facets: searchResult.facets,
          actualSort: searchResult.sorts.find((sort: ProductSort) => sort.selected)?.code,
          totalResult: !searchResult.query ? searchResult.pagination.totalResults : state.totalResult
        }
      ) as DevicesState
    }
  ),
  on(
    DeviceActions.loadById,
    DeviceActions.search,
    (state) => {
      return {...state, isSearching: true}
    }
  ),
  on(
    DeviceActions.loadByIdError,
    DeviceActions.searchError,
    (state) => {
      return {...state, isSearching: false}
    }
  ),
  on (
    DeviceActions.loadByIdSuccess,
    (state, { device  }) => adapter.upsertOne(device, {...state, isSearching: false})
  ),
  on (
    DeviceActions.removeDevicesFromStoreSuccess,
    (state, { devices  }) => adapter.removeMany(devices.map((device: Device) => device.id), {...state, isSearching: false})
  ),
  on (
    DeviceActions.updatePerPageSuccess,
    DeviceActions.updatePageSuccess,
    (state, { pagination  }) => {
      return {...state, pagination: pagination}
    }
  )
);

export function reducer(
  state: DevicesState | undefined,
  action: Action
) {
  return DevicesReducer(state, action);
}
